import React from 'react';
import { BadgeCheck, Truck, Hammer, ShieldCheck } from 'lucide-react';

// Slim assurance band shown under the home + shop heroes. One line each of the
// four things a first-time buyer (and a payment underwriter) checks for.
// Returns badge removed 2026-09-23 (owner request — don't promote returns);
// the 14-day policy itself remains published on /legal, which underwriters need.
const ITEMS = [
  { Icon: BadgeCheck, text: 'Exclusive Incolma distributor' },
  { Icon: Truck, text: 'Ships Canada-wide' },
  { Icon: Hammer, text: 'Full-tang drop-forged SAE 1075' },
  { Icon: ShieldCheck, text: '18+ · photo ID on delivery' },
];

const TrustStrip: React.FC = () => (
  <div className="bg-paper-bright border-b border-ink-200 py-4 px-6 lg:px-10">
    <div className="max-w-editorial mx-auto grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
      {ITEMS.map(({ Icon, text }) => (
        <div key={text} className="flex items-center gap-2.5 justify-start lg:justify-center">
          <Icon className="w-4 h-4 text-ember flex-shrink-0" strokeWidth={1.5} />
          <span className="font-mono text-[11px] tracking-[0.08em] uppercase text-ink-700">{text}</span>
        </div>
      ))}
    </div>
  </div>
);

export default TrustStrip;
